import { FC } from 'react';
import { BlueprintEntity } from '@agilelab/plugin-wb-builder-common';
import { WbNoData, WbTabPanel } from '@agilelab/plugin-wb-platform';
import { makeStyles } from '@material-ui/core';
import { BlueprintCard } from './BlueprintCard/BlueprintCard';
import { useBlueprintListContext } from './context/useBlueprintListContext';
import { Progress } from '@mainstage/core-components';

const useStyles = makeStyles(
  theme => ({
    root: {
      gap: theme.spacing(2),
      marginTop: theme.spacing(1),
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    },
  }),
  { name: 'BlueprintCards' },
);

export const BlueprintCards: FC = () => {
  const { entities, errors, loading } = useBlueprintListContext();

  const classes = useStyles();

  if (loading) return <Progress />;

  if (!entities.length) return <WbNoData />;

  return (
    <WbTabPanel value="grid" className={classes.root}>
      {entities.map(b => (
        <BlueprintCard
          blueprint={b as BlueprintEntity}
          key={b.metadata.name}
          error={errors?.find(e => e.entity_id === b.metadata.uid)}
        />
      ))}
    </WbTabPanel>
  );
};
